<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Dodawanie nowego materiału
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="material.name"
                                label="Nazwa materiału"
                                :error-messages="materialNameErrors"
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Dodaj"
                    :loading="actionLoading"
                    @click="addNewMaterial()"
                >
                    Dodaj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'AddNewMaterialDialog',
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            material: {
                name: null,
            },
            actionLoading: false,
        }
    },
    validations: {
        material: {
            name: {
                required
            },
        }
    },
    computed: {
        materialNameErrors() {
            const errors = []

            if (!this.$v.material.name.$dirty) return errors
            !this.$v.material.name.required && errors.push('Proszę podać nazwę materiału.')

            return errors
        },
    },
    methods: {
        addNewMaterial() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true
            let material = Object.assign({}, this.material)

            this.$emit('on-confirm', material)
            this.onClose()
        },
        onClose() {
            this.actionLoading = false
            setTimeout(() => {
                this.material.name = null
            }, 500)
            this.$v.$reset()
            this.$emit('on-close')
        },
    }
}
</script>

